import { render, staticRenderFns } from "./LogImportTable.vue?vue&type=template&id=82ac64e4"
import script from "./LogImportTable.vue?vue&type=script&lang=js"
export * from "./LogImportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports